"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const EFormeJuridique_1 = require("../../enums/Office/EFormeJuridique");
const EHabilitation_1 = require("../../enums/Office/EHabilitation");
const ELigneMetier_1 = require("../../enums/Office/ELigneMetier");
const ETypeConseiller_1 = require("../../enums/Office/ETypeConseiller");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const Custom_1 = __importDefault(require("../decorators/Custom"));
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../injectables/Di"));
const Resource_1 = __importDefault(require("../Resource"));
const OfficeProductRequestResource_1 = __importDefault(require("./OfficeProductRequestResource"));
class OfficeCreateRequestResource extends Resource_1.default {
}
exports.default = OfficeCreateRequestResource;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "raisonSociale", void 0);
__decorate([
    (0, CustomAsync_1.default)((siret) => Di_1.default.getOfficeService().isUniqueSiret(siret), {
        message: ValidationErrors_1.EValidationError.uniqueSiret,
    }),
    (0, class_validator_1.IsNumberString)({ no_symbols: true }),
    (0, class_validator_1.MaxLength)(14, { context: [14] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "siret", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "rcs", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EFormeJuridique_1.EFormeJuridique),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "formeJuridique", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OfficeCreateRequestResource.prototype, "capitalSocial", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "firstNameManager", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "lastNameManager", void 0);
__decorate([
    (0, Custom_1.default)((value) => new Date(value) < new Date(), { message: ValidationErrors_1.EValidationError.mustBeInThePast }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], OfficeCreateRequestResource.prototype, "birthDateManager", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "emailManager", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "emailAdminitratif", void 0);
__decorate([
    (0, class_validator_1.IsPhoneNumber)("FR"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "phoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "accountOwnerName", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(34, { context: [34] }),
    (0, class_validator_1.IsIBAN)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "iban", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(11, { context: [11] }),
    (0, class_validator_1.IsBIC)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "bic", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ETypeConseiller_1.ETypeConseiller),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "typeConseiller", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(EHabilitation_1.EHabilitation, { each: true }),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], OfficeCreateRequestResource.prototype, "habilitations", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, CustomAsync_1.default)((id) => Di_1.default.getAssociationProfessionnelleService().exists(id), {
        message: ValidationErrors_1.EValidationError.associationProfessionnelleNotExists,
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "associationProfessionnelleId", void 0);
__decorate([
    (0, class_validator_1.IsNumberString)({ no_symbols: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "numeroOrias", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ELigneMetier_1.ELigneMetier, { each: true }),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], OfficeCreateRequestResource.prototype, "ligneMetiers", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_transformer_1.Type)(() => OfficeProductRequestResource_1.default),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], OfficeCreateRequestResource.prototype, "products", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeCreateRequestResource.prototype, "membreReseau", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], OfficeCreateRequestResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], OfficeCreateRequestResource.prototype, "updatedAt", void 0);
